module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.0d9b62a0.ttf";